import { render, staticRenderFns } from "./DashboardOnboarding.vue?vue&type=template&id=93b70f8c&"
import script from "./DashboardOnboarding.vue?vue&type=script&lang=js&"
export * from "./DashboardOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOnboarding.vue?vue&type=style&index=0&id=93b70f8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports